import ExploreMixin from '@/mixins/ExploreMixin'
import TeamBuilder from '@/components/assemble/team/TeamBuilder'
import { bus } from '@/consts.js'
import _ from 'lodash'

export default {
  name: 'Team',
  template: '#team-template',
  mixins: [ExploreMixin],
  components: { TeamBuilder },
  data () {
    return {
      members: [
        {
          name: 'You',
          rank: null,
          rankName: ''
        },
        {
          name: 'Roger',
          rank: null,
          rankName: ''
        },
        {
          name: 'Steve',
          rank: null,
          rankName: ''
        },
        {
          name: 'Bob',
          rank: null,
          rankName: ''
        },
        {
          name: 'Billy',
          rank: null,
          rankName: ''
        }
      ],
      rankOptions: [
        {
          name: 'iron',
          value: 0.25
        },
        {
          name: 'bronze',
          value: 0.25
        },
        {
          name: 'silver',
          value: 1
        },
        {
          name: 'gold',
          value: 1.75
        },
        {
          name: 'platinum',
          value: 3
        },
        {
          name: 'diamond',
          value: 4.5
        },
        {
          name: 'master',
          value: 5.5
        },
        {
          name: 'grandmaster',
          value: 7
        },
        {
          name: 'challenger',
          value: 7
        }
      ],
      showPrompt: false,
      finished: false
    }
  },
  computed: {
    total () {
      let total = 0
      let members = this.getMemberVals()
      members.forEach((val) => {
        total += val
      })
      return total
    },
    average () {
      return this.total / this.teammateCount
    },
    score () {
      return this.average + ((1 / 3) * this.standardDeviation(this.getMemberVals()))
    },
    tier () {
      if (this.score < 1.695) {
        return 4
      } else if (this.score >= 1.695 && this.score < 2.435) {
        return 3
      } else if (this.score >= 2.435 && this.score < 3.35) {
        return 2
      } else if (this.score >= 3.35) {
        return 1
      }
    },
    romanTier () {
      if (this.tier === 1) {
        return 'I'
      } else if (this.tier === 2) {
        return 'II'
      } else if (this.tier === 3) {
        return 'III'
      } else if (this.tier === 4) {
        return 'IV'
      } else {
        return ' '
      }
    },
    teammateCount () {
      let count = 0
      this.members.forEach((member) => {
        if (member.rank && count <= 4) count++
      })
      return count
    }
  },
  methods: {
    averageFunc (data) {
      var sum = data.reduce(function (sum, value) {
        return sum + value
      }, 0)

      var avg = sum / data.length
      return avg
    },
    standardDeviation (array) {
      let avg = _.sum(array) / array.length
      return Math.sqrt(_.sum(_.map(array, (i) => Math.pow((i - avg), 2))) / array.length)
    },
    getMemberVals () {
      const memberVals = []
      this.members.map((member) => {
        if (member.rankName !== '') {
          memberVals.push(member.rank)
        }
      })
      return memberVals
    }
  },
  mounted () {
    bus.$on('changeRank', (obj) => {
      if (obj.memberIdx >= 0) {
        this.members[obj.memberIdx].rankName = this.rankOptions[obj.rankOptionsIdx].name
        this.members[obj.memberIdx].rank = this.rankOptions[obj.rankOptionsIdx].value
      }
      this.$nextTick(() => {
        this.$store.commit('setTier', this.tier)
      })
    })

    bus.$on('setFinished', () => {
      this.finished = true
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/assemble/Team.js